import React, { useMemo } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Alert, MobilePreview } from '@salecycle/ui-component-library';
import { useRcsTemplateEditorState } from '../context/useRcsTemplateEditorContext';
import { useListenAndMarkRcsPreviewRequired } from '../hooks/useListenAndMarkRcsPreviewRequired';
import { getCardFromCompiledRcs } from '../utils/rcsConfigToCardContent';
import { RichCard } from './RichCard';
import { RcsPreviewRequiredView } from './RcsPreviewRequiredView';
import {
  AlertContainer,
  RightPaneContent,
  RightPanePreviewArea,
  RightPaneWrapper,
  MobilePreviewContainer,
} from './style';

const MessageBubbleWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  padding: 12px 12px 24px;
  width: 100%;
  box-sizing: border-box;
`;

export const RcsTemplateEditorRightPane: React.FC = () => {
  const { t } = useTranslation(['designs']);
  const { requiresPreview, compiledTemplate, previewingVersion } = useRcsTemplateEditorState();

  useListenAndMarkRcsPreviewRequired();

  const cardContent = useMemo(() => getCardFromCompiledRcs(compiledTemplate), [compiledTemplate]);

  const showPreviewButton = requiresPreview || !compiledTemplate;

  return (
    <RightPaneWrapper data-testid="RcsTemplateEditorRightPane">
      <RightPaneContent>
        {previewingVersion && (
          <AlertContainer>
            <Alert
              variation="info"
              heading={t('designs:designGallery.templateEditor.versionHistory.previewMode.notification.title')}
              description={t('designs:designGallery.templateEditor.versionHistory.previewMode.notification.body')}
            />
          </AlertContainer>
        )}
        <RightPanePreviewArea>
          {showPreviewButton ? (
            <RcsPreviewRequiredView />
          ) : (
            <MobilePreviewContainer data-testid="RcsMobilePreviewContainer">
              <MobilePreview data-testid="RcsMobilePreview">
                <MessageBubbleWrapper>
                  <RichCard
                    card={cardContent ?? { title: '', text: '' }}
                    mediaPlaceholderText={t('rcsTemplateEditor.placeholders.image')}
                    titlePlaceholder={t('rcsTemplateEditor.placeholders.titleText')}
                    descriptionPlaceholder={t('rcsTemplateEditor.placeholders.descriptionText')}
                    mediaAltText={t('rcsTemplateEditor.placeholders.image')}
                    data-testid="RcsRichCard"
                  />
                </MessageBubbleWrapper>
              </MobilePreview>
            </MobilePreviewContainer>
          )}
        </RightPanePreviewArea>
      </RightPaneContent>
    </RightPaneWrapper>
  );
};
